import React from 'react'
import styled, { MQ_TABLET } from '../../constants/theme'
import ScrollableContent from '../blocks/ScrollableContent'
import StickyFooter from '../blocks/StickyFooter'

const NewsPage: React.FC = ({ children }) => (
  <React.Fragment>
    <ScrollableContent title="What's New">
      <InnerContent>
        <h2>WHAT'S NEW</h2>
        <p>
          As new features and improvements are released, you can check here to
          see how we're making your Virtual Care experience even better.
        </p>
        {children}
      </InnerContent>
    </ScrollableContent>
    <StickyFooter />
  </React.Fragment>
)

const InnerContent = styled.div(
  {
    '& .news-2018-6-20 li svg': {
      margin: '-8px 0',
    },
    '& .news-2018-6-6 li svg': {
      margin: '0px 10px -3px',
    },
    '& li': {
      '&:before': {
        borderRadius: '50%',
        content: '""',
        height: 4,
        left: 0,
        position: 'absolute',
        top: 9,
        width: 4,
      },
      listStyleType: 'none',
      marginLeft: 10,
      paddingLeft: 10,
      position: 'relative',
    },
    '& li + li': {
      marginTop: 10,
    },
    '& p + p': {
      marginTop: 20,
    },
  },
  ({ theme }) => ({
    ...MQ_TABLET({
      marginTop: theme.padding,
    }),
    '& li:before': {
      background: theme.text,
    },
    color: theme.text,
    marginTop: theme.paddingMobile,
  }),
)

export const DayDivider = styled.h3(
  {
    fontSize: 14,
    fontWeight: 'bold',
    margin: '40px 0 20px',
    textTransform: 'uppercase',
  },
  ({ theme }) => ({
    borderBottom: `2px solid ${theme.border}`,
  }),
)

export const Title = styled.h4({
  textTransform: 'uppercase',
})

export default NewsPage
